var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 32,
    viewBox: "0 0 188 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_57354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9145 10.3447L82.3394 31.5052H91.0661L93.0803 25.7599H96.3165L90.9145 10.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.301 31.5049H116.128L103.418 0.25293H96.3428L107.301 31.5049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V31.4535H8.05775V15.2687L15.3451 21.2579V11.3344L1.1578 0H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8777 0L19.7915 11.3219V21.2387L27.022 15.2236V31.4535H35.0797V0H33.8777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.011 30.331V22.8326C168.22 23.9807 170.864 24.8286 173.378 25.0494C174.244 25.129 175.07 25.129 175.851 25.0848C178.406 24.9171 179.838 24.2369 179.838 22.9563C179.838 21.3402 177.885 20.5275 174.074 19.1143C168.826 17.1623 165.445 15.0251 165.445 9.39894C165.445 3.77282 170.172 0.0986328 177.279 0.0986328C180.399 0.0986328 183.524 0.699285 185.602 1.55601V8.76308C183.739 7.60595 180.79 6.83756 177.93 6.83756C175.07 6.83756 173.248 7.818 173.248 9.35477C173.248 10.8032 175.07 11.7836 178.711 13.2321C183.955 15.2811 187.555 17.4538 187.555 22.9122C187.555 28.5823 183.218 32.0004 175.461 32.0004C171.905 32.0003 168.35 31.3114 166.011 30.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.738 0.518555H40.6377V31.4947H48.738V0.518555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.348 0.518555H152.248V31.4947H160.348V0.518555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8259 26.63L74.706 18.8564C75.2432 18.7646 75.78 18.6723 76.3173 18.4886C79.8974 17.3855 82.7617 14.5819 82.7617 9.89401C82.7617 3.96536 78.1521 0.518555 71.3943 0.518555H54.2988V31.4947H62.3992V20.6024V19.8672V13.8467V11.4112V6.72332H70.3203C73.095 6.72332 74.4822 8.2399 74.4822 10.1241C74.4822 12.4678 73.0055 13.8467 70.186 13.8467H66.7211V19.9888L73.4082 31.4949H77.8763L79.8259 26.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.861 7.25247L126.383 0.518555H116.358L127.233 15.8689L118.997 27.5587L120.602 31.4947H126.07L130.721 24.8585L130.861 7.25247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.421 15.8688L149.341 0.518555H139.451L134.9 7.24261L134.9 24.888L139.361 31.4947H149.386L138.421 15.8688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 31.5085L96.3426 0.256836L94.949 0.273989L93.2832 4.48477L103.195 31.5085H107.3Z",
    fill: "#D3D2D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_57354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187.556,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLogoWhite);
export default __webpack_public_path__ + "static/media/site-logo-white.d5d4d9d2d8c7b6f9e28dafd992fa0770.svg";
export { ForwardRef as ReactComponent };